import React from 'react';
import LoaderXPD from './Loader-xpdconnect.gif'

import './styles.scss';

function Loader(props) {
  return (
    <div className="loader-background" hidden={props.hidden}>
      <div className="loader">
        <img src={LoaderXPD} alt='loading' width={'100%'}/>
      </div>
    </div>
  );
}
export default Loader;